<template>
  <TextField
    inputId="fp-account-webview-url"
    name="webview"
    :label="translate(`${LOCALE_PREFIX}.form.freedomPay.accountWebviewURL`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.freedomPay.accountWebviewURLPlaceholder`)"
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_CASHLESS_PAYMENT;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
